import api from '../utils/api';

/**
 * Get all systems
 * @returns {Promise} - Promise with systems data
 */
export const getSystems = async () => {
  try {
    const response = await api.get('/systems');
    return response.data.data.systems;
  } catch (error) {
    console.error('Error fetching systems:', error);
    throw error;
  }
};

/**
 * Get system by ID
 * @param {string} id - System ID
 * @returns {Promise} - Promise with system data
 */
export const getSystemById = async (id) => {
  try {
    const response = await api.get(`/systems/${id}`);
    return response.data.data.system;
  } catch (error) {
    console.error(`Error fetching system ${id}:`, error);
    throw error;
  }
};

/**
 * Generate SSO URL for a system
 * @param {string} id - System ID
 * @returns {Promise} - Promise with SSO URL
 */
/**
 * Check if a system host is reachable (via Envoy API — no direct cross-origin /health calls)
 */
export const checkSystemHealth = async (id) => {
  try {
    const response = await api.get(`/systems/${id}/health`);
    return Boolean(response.data?.data?.online);
  } catch (error) {
    console.error(`Error checking health for system ${id}:`, error);
    return false;
  }
};

export const generateSsoUrl = async (id) => {
  try {
    const response = await api.get(`/systems/${id}/sso`);
    return response.data.data.ssoUrl;
  } catch (error) {
    console.error(`Error generating SSO URL for system ${id}:`, error);
    throw error;
  }
};
